var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-350 -280)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(350 280)",
    fill: "#f05e14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Compose",
    transform: "translate(356 286)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    width: 12,
    height: 12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M6.115,2.308,1.846,6.692,0,12l5.308-1.731L9.577,6Zm5.423-.346-1.5-1.5a1.4,1.4,0,0,0-2.077,0L6.692,1.731l3.462,3.577,1.385-1.385A1.463,1.463,0,0,0,12,2.885,1.424,1.424,0,0,0,11.538,1.962Z",
    fill: "#feffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCircle);
export default __webpack_public_path__ + "static/media/EditCircle.6e61a0cbfca194aa8885d1eb503288f8.svg";
export { ForwardRef as ReactComponent };